module.exports = __webpack_public_path__ + "static/media/pic1.00cf3df4.jpg";